import { Component, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { GfTranslateService } from '../../../core/services/core.translate.service';

@Component({
    selector: 'wiki-video-insert-modal',
    template: require('./wiki.video-insert-modal.component.html')
})
export class WikiVideoInsertModalComponent {

    /** Emits the validated video URL when user clicks Insert */
    @Output() insert = new EventEmitter<string>();

    /** Emits when user cancels */
    @Output() cancel = new EventEmitter<void>();

    /** The video URL entered by the user */
    videoUrl: string = '';

    /** Validation error message */
    errorMessage: string = '';

    /** Preview type detected from URL: 'youtube' | 'vimeo' | 'direct' | null */
    previewType: string = null;

    /** YouTube thumbnail URL for preview */
    thumbnailUrl: string = '';

    constructor(
        public activeModal: NgbActiveModal,
        private gfTranslateService: GfTranslateService
    ) {}

    onInsert(): void {
        const trimmed = (this.videoUrl || '').trim();
        if (!trimmed) return;

        if (!/^https?:\/\//i.test(trimmed)) {
            this.errorMessage = this.gfTranslateService.translate(
                'Please enter a valid URL starting with http:// or https://'
            );
            return;
        }

        this.errorMessage = '';
        this.insert.emit(trimmed);
        this.activeModal.close('inserted');
    }

    onCancel(): void {
        this.cancel.emit();
        this.activeModal.close('cancel');
    }

    /**
     * Called on ngModel change via the template — detect video type for preview.
     * We use a getter/setter pattern triggered from the template's ngModelChange.
     */
    onUrlChange(): void {
        this.errorMessage = '';
        const url = (this.videoUrl || '').trim();
        if (!url) {
            this.previewType = null;
            return;
        }

        const ytId = this.extractYoutubeId(url);
        if (ytId) {
            this.previewType = 'youtube';
            this.thumbnailUrl = 'https://img.youtube.com/vi/' + ytId + '/mqdefault.jpg';
            return;
        }

        if (/vimeo\.com/i.test(url)) {
            this.previewType = 'vimeo';
            return;
        }

        if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url)) {
            this.previewType = 'direct';
            return;
        }

        this.previewType = null;
    }

    private extractYoutubeId(url: string): string | null {
        const match = url.match(
            /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
        );
        return match ? match[1] : null;
    }
}
